export const SHARE_EXCHANGE_STEPS = [
  { step: 1, content: 'Review Information Memorandum and eSign the Introducer Agreement' },
  { step: 2, content: 'Complete the Appropriateness Questionnaire' },
  { step: 3, content: 'Complete the Application form' },
  { step: 4, content: 'Sign the Share Exchange Agreement (SEA)' },
  { step: 5, content: "Pay the introducer's fee Invoice (Payment)" },
  { step: 6, content: 'Sign the Stock Transfer Form' },
];
